import { MicrosoftReportProfileDelegate } from '../../../microsoft/profile/microsoft-report-profile-delegate';

export class OneDriveReportProfileDelegate extends MicrosoftReportProfileDelegate {
  hasInstantMessagingShare: boolean;
}
